import useGet from "../../actprep-ui/hooks/api/useGet";
import { apiUrls } from "../../actprep-ui/utils/urls";
import { Box } from "@mui/system";
import { Divider, Grid, Typography, Chip } from "@mui/material";
import { Add } from "@mui/icons-material";
import useDisclosure from "../../actprep-ui/hooks/ui/useDisclosure";
import AssignProgramDialog from "../AssignProgramDialog";
import { showSuccessSnackbar } from "../../actprep-ui/utils/feedback";
import api from "../../actprep-ui/utils/api";
import { useConfirm } from "material-ui-confirm";
import { fullName } from "../../actprep-ui/utils/formatting";
import ProgramAssignmentList from "../ProgramAssignmentList";

export default function AdminProfileForm({ adminProfileId }) {
  const confirm = useConfirm();
  const { data: adminProfileData } = useGet(
    apiUrls.admin.adminProfiles(adminProfileId),
    {
      params: {
        keep_related: true,
      },
      enabled: !!adminProfileId,
    }
  );
  const adminProfile = adminProfileData?.data;
  const { data: userProfileToProgramData, refetch: refetchPrograms } = useGet(
    apiUrls.admin.userProfileToProgram(),
    {
      params: {
        search_params: {
          user_profile_id: adminProfile?.user_profile?.uuid,
        },
        keep_related: true,
      },
      enabled: !!adminProfile,
    }
  );
  const assignProgramDisc = useDisclosure();

  const handleDelete = (userProfileToProgramId) => {
    confirm({
      title: "Are you sure?",
      description:
        "Please confirm that you want to unassign this user to the program.",
    })
      .then(async () => {
        const response = await api.delete(
          apiUrls.admin.userProfileToProgram(userProfileToProgramId)
        );
        if (response.status == 200) {
          showSuccessSnackbar("Program Unassigned!");
          refetchPrograms();
        }
      })
      .catch(() => {});
  };

  return (
    <>
      <AssignProgramDialog
        apiUrl={apiUrls.admin.userProfileToProgram()}
        defaultValues={{
          user_profile_id: adminProfile?.user_profile.uuid,
        }}
        {...assignProgramDisc.getDisclosureProps()}
        onSubmit={() => {
          assignProgramDisc.onClose();
          showSuccessSnackbar("Program Assigned!");
          refetchPrograms();
        }}
      />
      <Box>
        <Grid container spacing={2}>
          <Grid size={12}>
            <Typography variant="h5" fontWeight="bold" mb={1}>
              Admin Profile: {fullName(adminProfile?.user)}
            </Typography>
            <Divider />
          </Grid>
          <Grid size={12}>
            <Typography display="flex" alignItems="center" mb={1}>
              <span>Programs</span>
              <Chip
                label="Add"
                icon={<Add />}
                size="small"
                clickable
                sx={{ ml: 1 }}
                component={"span"}
                {...assignProgramDisc.getButtonProps()}
              />
            </Typography>
            {userProfileToProgramData?.data && (
              <ProgramAssignmentList
                onDelete={handleDelete}
                assignments={userProfileToProgramData.data}
              />
            )}
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
